module.exports = __webpack_public_path__ + "static/media/日语五十音记不住？唱就完事儿啦.d93b90bf.png";